import React from 'react';
import { Box, Grid, Typography, Rating } from '@mui/material';
import type { JoinedSparks } from 'types/Spark/JoinedSpark';
import SparkAvatarBackground from 'sharedComponents/UI/SparkAvatarBackground';
import SparkdefaultIcon from 'components/SVG/SparkdefaultIcon';
import { getReviewText } from 'utilities/index';
import { SparkImageLoader } from 'sharedComponents/UI';

interface StarRatingProps {
  averageRating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ averageRating }) => {
  return (
    <Rating
      name='customized-color'
      value={averageRating}
      precision={0.1}
      readOnly
      sx={{
        color: '#FFAC0C',
        '& .MuiRating-iconFilled': {
          color: '#FFAC0C',
        },
      }}
    />
  );
};

type Props = { spark: JoinedSparks; onClick: (sparkID: string) => void };

function SparkDropdownItem({ spark, onClick }: Props) {
  const { nameforHuman, descriptionforHuman } = spark?.attributes || {};
  const sparkMeta = spark.meta || {};
  return (
    <Grid
      item
      container
      xs={12}
      justifyContent='space-between'
      alignItems='center'
      component='div'
      onClick={() => onClick(spark.id)}
      padding={2}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          bgcolor: (theme) => theme.palette.borderColor,
        },
      }}
    >
      <Grid item flex={1} display='flex' alignItems='center'>
        <Box sx={{ display: 'flex', ml: 2 }}>
          {spark.attributes.logoURL ? (
            <SparkImageLoader
              width='55px'
              height='55px'
              style={{ borderRadius: '12px' }}
              src={spark?.attributes.logoURL}
              alt=''
            />
          ) : (
            <SparkAvatarBackground
              src={spark?.attributes?.iconURL || ''}
              icon={<SparkdefaultIcon width={'40px'} height={'40px'} />}
              width='55px'
              height='55px'
            />
          )}
        </Box>
        <Box marginLeft={2}>
          <Typography
            sx={{
              color: '#404040',
              fontSize: '16px',
              fontStyle: 'normal',
              lineHeight: 'normal',
              fontFamily: 'Mont-SemiBold',
            }}
          >
            {nameforHuman || '- -'}
          </Typography>
          <Typography
            variant='body2'
            sx={{
              color: '#4A4A4A',
              fontSize: '14px',
              fontStyle: 'normal',
              lineHeight: 'normal',
            }}
          >
            {descriptionforHuman || '- -'}
          </Typography>
        </Box>
      </Grid>
      <Grid item display='flex' gap={2}>
        <Box>
          <StarRating averageRating={sparkMeta.averageRating || 0} />
          <Typography
            variant='body2'
            sx={{
              color: '#4A4A4A',
              fontSize: '14px',
              fontStyle: 'normal',
              lineHeight: 'normal',
              marginLeft: 0.5,
            }}
          >
            {getReviewText(sparkMeta.numberOfRatings)}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default SparkDropdownItem;
